import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../element-variables.scss'
import locale from 'element-ui/lib/locale/lang/es'

Vue.use(Element, { locale })
